import React from 'react';
import { Modal, Text } from 'barte-design-system';

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  totalCount: number;
  selectedCount: number;
}

export function ExportModal({ isOpen, onClose, totalCount, selectedCount }: ExportModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      title="Exportar terminais"
      onClose={onClose}
      size="sm"
      footer={selectedCount > 0 ? {
        primaryButton: {
          children: `Exportar ${selectedCount} selecionado${selectedCount !== 1 ? 's' : ''}`,
          onClick: onClose,
        },
        secondaryButton: {
          children: `Exportar todos (${totalCount})`,
          variant: 'outline',
          onClick: onClose,
        },
      } : {
        primaryButton: {
          children: `Exportar todos (${totalCount})`,
          onClick: onClose,
        },
      }}
    >
      <Text variant="body-sm">
        {selectedCount > 0
          ? <>Serão exportados <strong>{selectedCount}</strong> terminais selecionados. Deseja exportar somente esses ou todos os terminais da listagem atual?</>
          : <>Serão exportados <strong>{totalCount}</strong> terminais da listagem atual.</>
        }
      </Text>
    </Modal>
  );
}
